<template>
    <div>
        <div
            class="d-flex w-100 align-items-center"
            :class="{ 'justify-content-center': align === 'center', 'justify-content-start': align === 'left' }"
        >
            <div class="p-1 d-flex align-items-center">
                <input
                    :id="fieldId"
                    :name="name"
                    type="checkbox"
                    class="vuetiful-input"
                    @input.stop.prevent="updateValue"
                    :checked="fieldValue"
                    :disabled="disabled"
                    ref="field"
                    @focus="onFocus"
                    @blur="onBlur"
                    :class="{ 'vuetiful-input-error': hasError }"
                />
            </div>

            <template v-if="hasLabelSlot || label">
                <label
                    :for="fieldId"
                    class="mt-0 mb-0 font-weight-normal vuetiful-label d-flex align-items-center"
                    :class="{ 'text-muted': disabled }"
                >
                    <slot v-if="hasLabelSlot"></slot>
                    <template v-else>{{ label }}</template>
                </label>
            </template>
        </div>

        <Transition name="fade-grow">
            <div
                v-if="hasError && currentError"
                class="mt-2 vuetiful-input-error-text d-flex align-items-center"
                :class="{ 'text-center': align === 'center', 'text-left': align === 'left' }"
            >
                <!-- padding classes are needed to align icon with the checkbox -->
                <i class="fa fa-exclamation-circle m-r-5 p-1 pr-0 p-t-0 p-b-0"></i> {{ currentError }}
            </div>
        </Transition>
    </div>
</template>

<script>
import GenerateId from '../mixins/GenerateId';
import { testIsBoolean } from '../../../../../lib/test-and-assert/test-base';

export default {
    name: 'SimpleCheckbox',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        currentError: {
            type: String,
            default: '',
        },
        align: {
            type: String,
            default: 'center',
            validator: function (val) {
                const allowedAlignments = ['left', 'center'];

                return allowedAlignments.includes(val);
            },
        },
    },
    mixins: [GenerateId],
    mounted() {
        this.fieldId = this.generateId();

        if (this.value) {
            this.fieldValue = this.value;

            return;
        }

        let autofilled = this.$refs['field'].checked;

        if (testIsBoolean(autofilled)) {
            this.fieldValue = autofilled;
        }
    },
    computed: {
        hasLabelSlot() {
            return !!this.$slots.default;
        },
    },
    watch: {
        fieldValue: function (val) {
            this.$emit('input', val);
        },
    },
    methods: {
        updateValue(event) {
            this.fieldValue = event.target.checked;
        },
        onFocus() {
            this.isFocused = true;
        },
        onBlur() {
            this.isFocused = false;
        },
    },
    data() {
        return {
            fieldValue: false,
            fieldId: null,
            isFocused: false,
        };
    },
};
</script>
